.outer {
    justify-content: space-between;
    width: 100%;
    padding: var(--mantine-spacing-sm);
    border-radius: var(--mantine-radius-sm);
    overflow: hidden;
    background-color: white;
}

.innerItem {
    flex: 1;
    font-size: var(--mantine-font-size-sm);
}

/* Toggle rows sit on a FeatureToggleGroup tint, not the white box. */
.flatRow {
    background-color: transparent;
}

/* The unchecked track (gray-3) is near-invisible on the group tints: make
   the off state white with a gray border/thumb. Scoped to unchecked so the
   checked (brand) state keeps its borderless look. Selector shape
   (input + track, thumb inside track) matches Mantine 8's Switch.css. */
.flatRow input:not(:checked) + .toggleTrack {
    --switch-bg: var(--mantine-color-white);
    border: 1px solid var(--mantine-color-gray-4);
}

.flatRow input:not(:checked) + .toggleTrack .toggleThumb {
    --switch-thumb-bg: var(--mantine-color-gray-5);
}

.disabledInput {
    --input-disabled-bg: white;
    --input-disabled-color: var(--mantine-color-dark-8);
    && {
        opacity: 1;
    }
}
